<template>
  <v-row
    align="center"
    justify="center"
  >
    <v-col cols="1">
      <v-row
        v-if="icon"
        align="center"
        justify="center"
      >
        <v-icon>
          {{ icon }}
        </v-icon>
      </v-row>
    </v-col>
    <slot name="content" />
  </v-row>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            default: null,
        },
    },
};
</script>
